var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import classnames from 'classnames';
import React from 'react';
import Icon from '../icon';
import Marquee from './Marquee';
export default class NoticeBar extends React.Component {
    constructor(props) {
        super(props);
        this.onClick = () => {
            const { mode, onClick } = this.props;
            if (onClick) {
                onClick();
            }
            if (mode === 'closable') {
                this.setState({
                    show: false,
                });
            }
        };
        this.state = {
            show: true,
        };
    }
    render() {
        const _a = this.props, { mode, icon, onClick, children, className, prefixCls, action, marqueeProps } = _a, restProps = __rest(_a, ["mode", "icon", "onClick", "children", "className", "prefixCls", "action", "marqueeProps"]);
        const extraProps = {};
        let operationDom = null;
        if (mode === 'closable') {
            operationDom = (<div className={`${prefixCls}-operation`} onClick={this.onClick} role="button" aria-label="close">
          {action ? action : <Icon type="cross" size="md"/>}
        </div>);
        }
        else {
            if (mode === 'link') {
                operationDom = (<div className={`${prefixCls}-operation`} role="button" aria-label="go to detail">
            {action ? action : <Icon type="right" size="md"/>}
          </div>);
            }
            extraProps.onClick = onClick;
        }
        const wrapCls = classnames(prefixCls, className);
        return this.state.show ? (<div className={wrapCls} {...restProps} {...extraProps} role="alert">
        {icon && (
        // tslint:disable-next-line:jsx-no-multiline-js
        <div className={`${prefixCls}-icon`} aria-hidden="true">
            {icon}
          </div>)}
        <div className={`${prefixCls}-content`}>
          <Marquee prefixCls={prefixCls} text={children} {...marqueeProps}/>
        </div>
        {operationDom}
      </div>) : null;
    }
}
NoticeBar.defaultProps = {
    prefixCls: 'am-notice-bar',
    mode: '',
    icon: <Icon type="voice" size="xxs"/>,
    onClick() { },
};



// WEBPACK FOOTER //
// ./components/notice-bar/index.tsx